import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { resourceScopeCleared, userScopeCleared } from '@krp/client-runtime'

import { aqsiShift } from '../api/rmkApi'

/** Только расписание чтения. Факт смены и разрешение оплаты здесь не сохраняются. */
const initialState: Record<string, number> = {}
export const SHIFT_READ_GAP_MS = 15_000
export const shiftReadKey = (resourceId: string, deviceId: number): string => `${resourceId.toLowerCase()}:${deviceId}`

const slice = createSlice({
  name: 'aqsi/shiftReads',
  initialState,
  reducers: {
    shiftReadsRestored: (_state, action: PayloadAction<Record<string, number>>) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(userScopeCleared, () => initialState)
    builder.addCase(resourceScopeCleared, (state, action) => {
      for (const key of Object.keys(state)) if (key.startsWith(`${action.payload.resourceId.toLowerCase()}:`)) delete state[key]
    })
    builder.addMatcher(aqsiShift.matchPending, (state, action) => {
      const { resourceId, deviceId } = action.meta.arg.originalArgs
      state[shiftReadKey(resourceId, deviceId)] = action.meta.startedTimeStamp
    })
  },
})

export const shiftReadsReducer = slice.reducer
export const { shiftReadsRestored } = slice.actions

export function decodeShiftReads(raw: unknown): Record<string, number> {
  if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) return {}
  const now = Date.now()
  return Object.fromEntries(Object.entries(raw).filter(([key, at]) =>
    /^[0-9a-f-]{36}:\d+$/.test(key) && typeof at === 'number' && Number.isFinite(at) && at <= now && now - at < SHIFT_READ_GAP_MS,
  ))
}
